import React from "react";
import MainLayout from "./MainLayout";
import DescriptionMasterV2 from "../common/MainContent/JobDescription/DescriptionMasterV2";

const JobDetailsPage = (props) => (
  <MainLayout component={DescriptionMasterV2} adjustFooter location={props.location} />
);

export default JobDetailsPage;
